<template>
  <div style="height: calc(100vh - 230px);width: 100%">
    <div class="hosLog"  v-loading="loading">

    <template v-if="type == 0">
    <div class="hosLog-header">
      <div class="hosLog-title">Truck Info</div>
      <div class="hosLog-item" v-if="license">
        <div>License Plate</div>
        <div>{{license}}</div>
      </div>
      <div class="hosLog-item" v-if="vin">
        <div>VIN#</div>
        <div>{{vin}}</div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="item.id">
        <div :class="{'item-left': true, 
                          'onDuty-role': item.bigRoleStatus == 'Stopped', 
                          'driving-role': item.bigRoleStatus == 'In Progress', 
                          'offDuty-role': item.bigRoleStatus == 'No Data' }">
          <span class="item-roll" >
          </span>
          <template>
            <span 
              v-for="it in item.role" 
              :key="it" 
              :class="{'role': true,
                'onDuty-item': item.statusTime == 'Stopped', 
                'driving-item': item.statusTime == 'In Progress', 
                'offDuty-item': item.statusTime == 'No Data'
              }"></span>
          </template>
        </div>
        <div class="item-right">
          <template>
            <div class="item-address" >
              <span class="item-address-detail">
                <common-ellipsis-tooltip
                  effect="dark"
                  :content="item.location || 'No location'"
                  placement="top"
                >
                </common-ellipsis-tooltip>
              </span>
              <div v-if="index == 0" class="item-tips">Latest Update</div>
            </div>
            <div class="item-time">
              <common-ellipsis-tooltip
                effect="dark"
                :content="timeZone(item.localTime)"
                placement="top"
              >
              </common-ellipsis-tooltip>
            </div>
          </template>
          <div class="item-status" v-if="index !== list.length - 1">
           <div :class="{ 'item-status-btn': true, 
                          'onDuty': item.statusTime == 'Stopped', 
                          'driving': item.statusTime == 'In Progress', 
                          'offDuty': item.statusTime == 'No Data' }">
             <span>{{item.statusTime}}</span>
             <span class="item-status-desc">
               {{item.distance ? (item.roleTime + ',') : item.roleTime}}
               {{item.distance ? (item.distance + 'mi') : ''}}</span>
           </div>
          </div>
        </div>
      </div>
    </div>
    </template>
    <div class="empty" v-else>
      <No-data :type="type" :dsp_permission="dsp_permission"></No-data>
    </div>
     </div>
  </div>
</template>
<script>
import NoData from './no-data.vue'
import moment from 'moment'
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import { getTrackingHos } from '@/api/dispatch' 
// import {filterEventOb$} from "@/services/push";
// import {ELD_REFRESH} from "@/services/push/events";
// import { systemInfo } from '@/shared-services'
export default {
  name: 'hosLog',
  components: {
    NoData
  },
  props: {
    dsp_permission: {
      type: Boolean,
      default: true
    },
    target: Element,
    getHosApi: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: ''
    },
    hosLog: {
      type: Object
    },
  },
  data() {
    return {
      list: [],
      type: 0,
      loading: false,
      vin: '',
      license: ''
    }
  },
  computed: {
    ...mapState("user", [
      'connectEld'
    ]),
  },
  watch: {
    getHosApi(val) {
      if(val) {
        this.getHosDatail()
      }
    },
    hosLog: {
      handler(){
        if (this.source) {
          if(this.hosLog && Object.keys(this.hosLog).length) {
            this.handlerData(this.hosLog)
          } else {
            this.type = 5
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    timeZone(data) {
      if (!data) return '--'
      return moment.tz(data, moment.tz.guess()).format("MMM DD, YYYY, HH:mm z")
    },
    getTime(a, b) {
      let time1 = this.timeZone(a)
      let time2 = this.timeZone(b)
      if(a !== '--' && b !== '--') {
        time1 = moment(time1).format('x')
        time2 = moment(time2).format('x')
        let str = ''
        let ago = (time2 - time1) / 1000 / 60
        let day = Math.floor(ago / ( 60 * 24))
        if (day) {
          str = `${day}d`
          ago = ago - day * 60 * 24
        }
        let hour = Math.floor(ago / 60)
        str = str ? str + `${hour}h` : hour ? `${hour}h` : ''
        if (hour) {
          ago = ago - hour * 60
        }
        let min = parseInt(ago)
        return str + `${min}mins`
      } else {
        return ''
      }
    },
    computedHeight(l1, l2) {
      if (l1 && l2) {
        let len = l2 - l1
        let min = Math.floor(len / (60 * 1000 * 5))
        if (min < 12) {
          return 12
        } else if (min > 60) {
          return 60
        } else {
          return min
        }
      }
    },
    getHosDatail() {
      this.loading = true
      // let data = {}
      //  data.currentLocation = [
      //      {
      //           // "status": "In Progress",
      //           // "status": "In Progress",
      //           "status": "NO Data",
      //           "localTime": 1655636895000,
      //           "location": "I 10, Palm Desert, CA, 92211-0817",
      //           // "currentOdometer": null,
      //           // "distance": null
      //       },
      //       {
      //           "status": "Stopped",
      //           // "status": "NO Data",
      //           "localTime": 1655617681000,
      //           "location": "14685 Warren Street, Kern County, CA, 93249",
      //           "currentOdometer": null,
      //           "distance": null
      //       },
      //       {
      //           "status": "Stopped",
      //           // "status": "NO Data",
      //           "localTime": 1655617681000,
      //           "location": "14685 Warren Street, Kern County, CA, 93249",
      //           "currentOdometer": null,
      //           "distance": null
      //       },
      //       {
      //           // "status": "In Progress",
      //           "status": "NO Data",
      //           "localTime": 1655614085000,
      //           "location": "Paso Robles Highway, Kecks Corner, CA",
      //           "currentOdometer": null,
      //           "distance": null
      //       },
      //       {
      //           "status": "Stopped",
      //           "localTime": 1655604509000,
      //           "location": "Harris Road, Spreckels, CA, 93962",
      //           "currentOdometer": null,
      //           "distance": null
      //       },
      //   ]
      //   data.currentLocation.forEach((item, index) => {
      //     if (index > 0) {
      //       data.currentLocation[index - 1].role = this.computedHeight(item.localTime, data.currentLocation[index - 1].localTime)
      //       data.currentLocation[index - 1].roleTime = this.getTime(item.localTime, data.currentLocation[index - 1].localTime)
      //       data.currentLocation[index - 1].statusTime = item.status
      //     }
      //     if (item.status == 'No Data' && data.currentLocation[index + 1]) {
      //       item.bigRoleStatus = data.currentLocation[index + 1].status
      //     } else {
      //       item.bigRoleStatus = item.status
      //     }
      //   })
      //   if (data.currentLocation[0]) {
      //     data.currentLocation[0].bigRoleStatus = data.currentLocation[0].status
      //     if (data.currentLocation[0].status == 'No Data') {
      //       data.currentLocation[0].statusTime = 'No Data'
      //     }
      //   }

      //   console.log(data, 'status')
        // this.list = data.currentLocation
      getTrackingHos({loadId: this.$route.query.id }).then(res => {
        console.log(res)
        this.loading = false
        const data = res.data
        this.handlerData(data)
      }, (res) => {
        this.loading = false
        switch(res.code) {
          case 40013: 
            this.type = 3
          break;
          case 60009: 
            this.type = 1
          break;
          case 40012: 
            this.type = 4
          break;
          case 60008: 
            this.type = 2
          break;
          default: 
            Message.error(res.message || 'Service error, please try again')
        }
      })
    },
    handlerData(data) {
      data.currentLocation.forEach((item, index) => {
          if (index > 0) {
            data.currentLocation[index - 1].role = this.computedHeight(item.localTime, data.currentLocation[index - 1].localTime)
            data.currentLocation[index - 1].roleTime = this.getTime(item.localTime, data.currentLocation[index - 1].localTime)
            data.currentLocation[index - 1].statusTime = item.status
          }
          if (item.status == 'No Data' && data.currentLocation[index + 1]) {
            item.bigRoleStatus = data.currentLocation[index + 1].status
          } else {
            item.bigRoleStatus = item.status
          }
        })
        if (data.currentLocation[0]) {
          data.currentLocation[0].bigRoleStatus = data.currentLocation[0].status
          if (data.currentLocation[0].status == 'No Data') {
            data.currentLocation[0].statusTime = 'No Data'
          }
        }

        console.log(data, 'status')
        this.list = data.currentLocation
        this.vin = data.truckVin
        this.license = data.licensePlate
    }
  },
  mounted() {
    if(this.target) {
      this.target.appendChild(this.$el)
    }
  },
  created() {
    if (!this.source) {
      this.getHosDatail()
    }
    
    // if (systemInfo.isCommand) {
    //   this.$event = filterEventOb$(ELD_REFRESH).subscribe(() => {
    //     this.getHosDatail();
    //   })
    // }
  },
  // beforeDestroy() {
  //   this.$event && this.$event.unsubscribe()
  // },
}
</script>
<style lang="scss" scoped>
.hosLog-header{
  width: 376px;
  padding: 16px 0px;
  border-bottom: 1px solid #E7EBF3;
}
.hosLog-title{
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  color: #000;
  margin-bottom: 12px;
}
.hosLog-item{
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:first-child{
    margin-top: 0;
  }

  &>div:first-child{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #7F8596;
  }
  &>div:last-child{
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    font-style: normal;
    color: #000000;
  }
}
.hosLog{
  height: calc(100% - 47px);
  background: #fff;
  // padding-top: 24px;
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  width: calc(100% - 4px);
  // padding-right: 4px;
  // overflow-y: auto;
  //  &::-webkit-scrollbar {
  //     display: block;
  //     width: 8px;
  //     height: 8px;
  //     // background-color: rgba(0, 0, 0, 0.3);
  //   }
  //   &::-webkit-scrollbar-track {
  //     border-radius: 4px;
  //   }
  //   &::-webkit-scrollbar-thumb {
  //     width: 8px;
  //     height: 8px;
  //     border-radius: 4px;
  //     background-color: rgba(0, 0, 0, 0.3);
  //     &:hover {
  //       // background-color: rgba(0, 0, 0, 0.5);
  //     }
  //   }
}
.empty{
  padding-right: 32px;
  width: 100%;
  height: 100%;
}
.item{
  margin-bottom: 6px;
  display: flex;
  width: 100%;

  &:first-child{
    .item-address-detail{
      width: 251px;
    }
  }
}
.item-left{
  margin-right: 12px;
  width: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  span{
    margin-top: 4px;
    width: 2px;
    height: 2px;
    background: #000;
    display: inline-block;
    border-radius: 50%;
    &:first-child{
      width: 10px;
      height: 10px;
      margin-top: 0;
    }
  }
  .item-roll{}
}
.list{
  padding-right: 20px;
  overflow-y: auto;
  padding-top: 16px;
  padding-bottom: 16px;
    &::-webkit-scrollbar {
      display: block;
      width: 8px;
      height: 8px;
      // background-color: rgba(0, 0, 0, 0.3);
    }
    &::-webkit-scrollbar-track {
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.3);
      &:hover {
        // background-color: rgba(0, 0, 0, 0.5);
      }
    }
}
.item-address{
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #4C556C;
  height: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;


  .item-address-detail{
    width: 100%;
    ::v-deep span{
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #4C556C;
    }
  }
}
.item-tips{
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #7F8596;
  
}
.item-right{
  display: flex;
  flex-direction: column;
  width: calc(100% - 22px);
}
.item-time {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #7F8596;
  height: 16px;
  margin-top: 4px;

  ::v-deep span{
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #7F8596;
  }
}
.item-status{
  // height: calc(100% - 36px);
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 8px;
}
.item-status-btn{
  height: 30px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
  border: 1px solid #F08226;

  & > span:first-child{
    // width: 56px;
    padding: 1px 4px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    font-weight: 400;
    font-size: 12px;
    border-radius: 2px;
    text-align: center;
  }
}
.item-status-desc{
  margin-left: 6px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #000;
}
.onDuty{
  border-color: #F08226;
  &>span:first-child{
    background: #FDEDE0;
    color: #F08226;
  }
}
.onDuty-role{
  span{
    background: #F08226;
  }
}
.onDuty-item {
  background: #F08226 !important;
}
.offDuty{
  border-color: #4C556C;
  &>span:first-child{
    background: #DADCE1;
    color: #4C556C;
  }
}
.offDuty-role{
  span:first-child{
    // visibility: hidden;
    background: #4C556C;
  }
}
.offDuty-item {
   background: #4C556C !important;
}
.driving{
  border-color: #00B386;
  &>span:first-child{
    background: #ECF7F3;
    color: #00B386;
  }
}
.driving-role{
  span{
    background: #00B386;
  }
}
.driving-item{
  background: #00B386 !important;
}
.only-item-status{
  margin-top: 12px;
  font-weight: 500;
  font-size: 12px;
  width: 55px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  color: #4C556C;
  background: #DADCE1;
  border-radius: 2px;
}
</style>
